import Vue from 'vue'
import paper from 'paper';
// import {
//   DrawAction
// } from '../../tools/action';

const state = {
  socket: {
    isConnected: false,
    message: '',
    reconnectError: false,
  },
  boardId: '',

};

const mutations = {
  SOCKET_ONOPEN(state, event) {
    Vue.prototype.$socket = event.currentTarget
    state.socket.isConnected = true
    // eslint-disable-next-line no-console
    console.log('Websocket Connected')
  },
  SOCKET_ONCLOSE(state) {
    state.socket.isConnected = false
  },
  SOCKET_ONERROR(state, event) {
    // eslint-disable-next-line no-console
    console.error(state, event)
  },
  // default handler called for all methods
  SOCKET_ONMESSAGE(state, message) {
    state.socket.message = message
    let _data = JSON.parse(message.data)
    // eslint-disable-next-line no-console
    console.log('SOCKET_ONMESSAGE, data: ', _data)
    if (_data.route === 'init') {
      // eslint-disable-next-line no-console
      console.log('Route: init')
      state.boardId = _data.item.boardId
      paper.project.importJSON(_data.item.data)
      if(_data.item.drawActions.length > 0){
        //we already have draw actions (layers) to add
        _data.item.drawActions.forEach(aDrawAction => {
          let layer = new paper.Layer()
          layer.importJSON(aDrawAction)
        });
      }
    } else if (_data.route === 'broadcast') {
      // eslint-disable-next-line no-console
      console.log('Route: broadcast')
      // eslint-disable-next-line no-console
      console.log('received layername', JSON.parse(_data.message)[1].name)
      if (!paper.project.layers[JSON.parse(_data.message)[1].name]) {
        let layer = new paper.Layer()
        layer.importJSON(_data.message)
      }
      
      // eslint-disable-next-line no-console
      // console.log('Socket Received layer:', layer)
      

      // let flag = false
      // paper.project.layers.some(element => {
      //   // eslint-disable-next-line no-console
      //   console.log('layers el name', element.name)
      //   // el.name === layer.name
      //   if (element.name === layer.name) flag = true
      // })
      // // eslint-disable-next-line no-console
      // console.log('found:', flag)
      // if (!flag) {
      //   // eslint-disable-next-line no-console
      //   console.log('pushing layer:', flag)
      //   paper.project.layers.push(layer)
      // }

    }

  },
  // mutations for reconnect methods
  SOCKET_RECONNECT(state, count) {
    // eslint-disable-next-line no-console
    console.info(state, count)
  },
  SOCKET_RECONNECT_ERROR(state) {
    state.socket.reconnectError = true;
  },
}


const actions = {
  sendMessage: (context, message) => {

    if (state.socket.isConnected) {
      // eslint-disable-next-line no-console
      // console.info('connected, sending message to wss', message, 'board ID: ', state.boardId)
      const socketArgs = {
        action: 'broadcast',
        boardId: state.boardId,
        message
      }
      // eslint-disable-next-line no-console
      // console.info('$socket: ', Vue.prototype.$socket)
      Vue.prototype.$socket.send(JSON.stringify(socketArgs))

    } else {
      // eslint-disable-next-line no-console
      // console.info('disconnected, not sending action')
    }
  }
}

const getters = {
  boardId(state) {
    return state.boardId;
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}